import type { ConfigLayerOptions } from 'config/ConfigLayer'
import { createMapboxLayer } from 'config/Mapbox'
import { MapLayer } from 'config/MapLayer'

export class MapLayerMapBox extends MapLayer {
  static createLayer (layerConf: ConfigLayerOptions) {
    this.preLayer(layerConf)

    const olLayer = createMapboxLayer(layerConf)
    return olLayer
  }
}
